import React from 'react';

const FilterIconV2 = ({ className }) => (
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.81747 12V10H8.72656V12H5.81747ZM2.90838 7V5H11.6357V7H2.90838ZM0.726562 2V0H13.8175V2H0.726562Z"
      fill="black"
    />
  </svg>
);

export default FilterIconV2;
